import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { blacklistRegex, formMetadata } from "../../constants";
import PhoneInput from './phoneInput';
import FormMessage from './formMessage';
import Loader from '../../components/loader';

function getInvalidFields(formData) {
    let invalidFields = [];

    for (const property in formData) {
        if (formMetadata[property].isRequired && formData[property] === "") {
            invalidFields.push(`'${formMetadata[property].name}' is required`);
        }
    }

    return invalidFields;
}

function WelcomeForm(props) {
    let { onSubmit, value, hideSubmitButton, displayMessage, apiCallStatus, apiCallSuccess, visitId } = props;

    const [validated, setValidated] = useState(false);
    const [invalidFields, setInvalidFields] = useState([]);

    let alert = useRef(null);

    const [alertClosed, setAlertClosed] = useState(null);

    const [formData, setFormData] = useState({
        ...value
    });

    useEffect(() => {
        setFormData({
            ...value
        });
    }, [value])

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if ((target.type === "text" || target.type === "email") && blacklistRegex.test(target.value)) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            let objectUpdate =  {
                ...formData,
                [name]: value,
                userConfigId: ""
            };

            setFormData(objectUpdate);
        }
    };

    const onFormSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.target.checkValidity() == false) {
            setInvalidFields(getInvalidFields(formData));
            setAlertClosed(false);
        }
        else {
            setInvalidFields([]);
            setAlertClosed(true);
            onSubmit(formData);
        }

        setValidated(true);
    };
    return (
        <div className="welcome-form m-auto">
            <div className="m-auto">
                <form noValidate onSubmit={onFormSubmit} className={`wbm-leads-form form-group ${validated ? "was-validated" : "needs-validation"} m-auto`} >
                    <div ref={alert} className={`alert alert-danger fade ${validated && !alertClosed ? "show" : "hide"}`} role="alert">
                        {invalidFields.map((x,i) => { return <strong key={i}>{x}<br/></strong>; })}
                    </div>
                    *Required Information
                    <input type="text" aria-label="First Name" className="textbox form-control" required name="firstName" placeholder="*First Name" value={formData.firstName} onChange={handleInputChange} />
                    <input type="text" aria-label="Last Name" className="textbox form-control" required name="lastName" placeholder="*Last Name" value={formData.lastName} onChange={handleInputChange} />
                    <input type="text" aria-label="Business Name" className="textbox form-control" required name="businessName" placeholder="*Business Name" value={formData.businessName} onChange={handleInputChange} />
                    <input type="email" aria-label="Email" className="textbox form-control" required name="email" placeholder="*Email" value={formData.email} onChange={handleInputChange} />
                    <PhoneInput
                        aria-label="Phone Number"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        placeholder="*Phone Number"
                        required
                        name="phoneNumber"
                        className="textbox form-control"
                        type="tel"
                    />
                    <input type="text" aria-label="City" className="textbox form-control" required name="city" placeholder="*City" value={formData.city} onChange={handleInputChange} />
                    <input type="text" aria-label="State" className="textbox form-control" required name="state" placeholder="*State" value={formData.state} onChange={handleInputChange} />

                    <div className="drop">
                        <label htmlFor="hearAbout">
                                <b>How did you hear about us?</b>
                        </label>
                        <select name="hearAbout" id="hearAbout" onChange={handleInputChange} defaultValue="">
                            <option value="" disabled hidden>Select One</option>
                            <option value="Sales Rep">Sales Rep</option>
                            <option value="Sports" >Sports</option>
                            <option value="The Trucks" >The Trucks</option>
                            <option value="Referred by a Friend" >Referred by a friend</option>
                            <option value="Google/Search Engine">Google/Search Engine</option >
                            <option value="Youtube" >Youtube</option >
                            <option value="Social Media">Social Media</option >
                            <option value="Other">Other</option >
                        </select>
                    </div>
                    <div className="contact-preferences">
                        <div className="contact-header">
                            Contact Preferences:
                        </div>
                        <div className="contact-type" >
                            <input type="radio" id="cpPhone" name="contactPreferences" value="phone" onChange={handleInputChange} />
                            <label htmlFor="cpPhone">Phone</label>
                        </div>    
                        <div className="contact-type" >
                            <input type="radio" id="cpEmail" name="contactPreferences" value="email" onChange={handleInputChange} /> 
                            <label htmlFor="cpEmail">Email</label>
                        </div> 
                    </div>
                    <br />
                    <input type="hidden" name="userConfigId" value={formData.userConfigId || ""} />
                    <input type="hidden" name="accountNumber" value={formData.accountNumber || ""} />
                    <input type="hidden" name="leadSource" value={formData.leadSource || ""} />
                    <input type="hidden" name="campaignId" value={formData.campaignId || ""} />
                    <input type="hidden" name="icId" value={formData.icId || ""} />
                    <input type="hidden" name="referringDomain" value={formData.referringDomain || ""} />
                    <input type="hidden" name="paidSearch" value={formData.paidSearch || ""} />
                    <input type="hidden" name="sessionID" value={visitId || ""} />
                    {displayMessage &&
                        <FormMessage
                            apiSuccess={apiCallSuccess}
                            firstName={formData.firstName}
                            lastName={formData.lastName}
                        />
                    }
                    <div className={`text-center pb-3 form-submit-button 
                        ${hideSubmitButton ? "d-none" : ""}`}>
                        <input type="submit" className="submit-button" value="Submit" />
                    </div>
                    <div className={`${apiCallStatus ? "d-none" : ""}`}>
                        {hideSubmitButton ?
                            <div className="form-loader">
                                <Loader />
                            </div> :
                            ""
                        }
                    </div>
                </form>
            </div>
        </div>
    );
};
WelcomeForm.propTypes = {
    onSubmit: PropTypes.func
};

export default WelcomeForm;